"use client";

import type { ReactNode } from "react";

import * as NavigationMenu from "@radix-ui/react-navigation-menu";
import clsx from "clsx";
import Image from "next/image";
import { useState } from "react";

import type { NavigationItem } from "@/src/components/navigation/NavigationItems";

import { LegacyUrl, legacyUrls } from "@/src/app/legacyUrls";
import { brandName } from "@/src/app/metadata";
import { NavigationItems } from "@/src/components/navigation/NavigationItems";

interface NavigationProps {
  readonly consumerItems: NavigationItem[];
  readonly memberItems: NavigationItem[];
}

export function Navigation({
  consumerItems,
  memberItems,
}: NavigationProps): ReactNode {
  const [opened, setOpened] = useState(false);
  return (
    <NavigationMenu.Root
      className="bg-primary sticky top-0 z-50 h-14 text-white"
      onValueChange={(value) => {
        setOpened(value !== "");
      }}
    >
      <div
        className={clsx(
          "relative flex min-h-full w-full basis-52 items-center justify-between text-white",
          "lg:basis-60",
        )}
      >
        <NavigationMenu.Link asChild>
          <a
            className={clsx(
              "flex h-14 items-center px-3 transition-all",
              "hover:bg-primary-hover hover:rounded-br",
            )}
            href={legacyUrls[LegacyUrl.home]}
          >
            <Image
              alt={brandName}
              height={34}
              src="/logos/cqlp-white-inline.svg"
              width={133}
            />
          </a>
        </NavigationMenu.Link>
        <NavigationItems
          consumerItems={consumerItems}
          memberItems={memberItems}
          opened={opened}
        />
      </div>
    </NavigationMenu.Root>
  );
}
